import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=60f27680&scoped=true&"
import script from "./BaseMenu.vue?vue&type=script&lang=js&"
export * from "./BaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=60f27680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f27680",
  null
  
)

export default component.exports